module.exports = __webpack_public_path__ + "img/info-o.e491566d.svg";